import { useState, useEffect } from 'react';
import { MdAttachMoney, MdCheckCircle, MdOutlineCancel } from "react-icons/md";
import { AiOutlineLoading, AiOutlineClose } from "react-icons/ai";
import ClientService from '../../../../rest/clientService';
import ModalPortal from '../../../../components/lib/modalPortal';
import PaymentSelect from '../../../../components/reusables/paymentSelect';

const RegistryTransactionModal = ({ isOpen, onClose, onConfirm, type, loading }) => {
    const [value, setValue] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("");
    const [enabledPayments, setEnabledPayments] = useState([]);

    useEffect(() => {
        if (isOpen) {
            const fetchPayments = async () => {
                try {
                    const prefs = await ClientService.getClientAdminPreferences();
                    const enabled = prefs?.accepted_payments
                        ?.split(";")
                        .map(v => v.trim().toUpperCase())
                        .filter(Boolean) || [];
                    setEnabledPayments(enabled);
                } catch (error) {
                    console.error("Erro ao buscar pagamentos:", error);
                }
            };
            fetchPayments();
            setValue("");
            setPaymentMethod("");
        }
    }, [isOpen]);

    const handleSubmit = () => {
        if (!value || Number(value) <= 0) {
            alert("Por favor, informe um valor válido maior que zero.");
            return;
        }
        if (!paymentMethod) {
            alert("Por favor, selecione a forma de movimentação.");
            return;
        }

        onConfirm({
            value: Number(value),
            paymentMethod
        });
    };

    if (!isOpen) return null;

    const isInput = type === 'inputValue';
    const title = isInput ? "Lançar Entrada no Caixa" : "Lançar Saída do Caixa";
    const colorClass = isInput ? "text-green-600 bg-green-50" : "text-red-600 bg-red-50";
    const buttonBg = isInput ? "bg-green-600 hover:bg-green-700" : "bg-red-600 hover:bg-red-700";

    return (
        <ModalPortal>
            <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
                <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-md animate-in zoom-in duration-200 flex flex-col">
                    <div className="flex justify-between items-center mb-6">
                        <div className="flex items-center gap-3">
                            <div className={`p-3 rounded-full ${colorClass}`}>
                                <MdAttachMoney size={28} />
                            </div>
                            <h3 className="text-xl font-bold text-gray-800 leading-tight">
                                {title}
                            </h3>
                        </div>
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-600 hover:bg-slate-100 p-2 rounded-full transition-colors"
                        >
                            <AiOutlineClose size={24} />
                        </button>
                    </div>

                    <div className="space-y-5">
                        <div>
                            <label className="block text-xs font-bold text-gray-500 mb-1 uppercase tracking-wide">
                                Valor (R$)
                            </label>
                            <div className="relative">
                                <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-bold">R$</span>
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0.01"
                                    placeholder="0.00"
                                    className="w-full pl-10 pr-4 py-3 text-xl font-bold text-gray-800 border-2 border-slate-200 rounded-xl focus:border-custom_blue focus:ring-4 focus:ring-custom_blue/10 outline-none transition-all placeholder:text-gray-300"
                                    value={value}
                                    onChange={(e) => setValue(e.target.value)}
                                    autoFocus
                                />
                            </div>
                        </div>

                        <div>
                            <label className="block text-xs font-bold text-gray-500 mb-1 uppercase tracking-wide">
                                Forma de Movimentação
                            </label>
                            <PaymentSelect
                                enabledValues={enabledPayments}
                                value={paymentMethod}
                                onChange={setPaymentMethod}
                            />
                            <p className="text-[10px] text-gray-400 mt-1">
                                Selecione como o dinheiro entrou ou saiu do caixa físico.
                            </p>
                        </div>
                    </div>

                    <div className="flex gap-3 mt-8 pt-4 border-t border-slate-100">
                        <button
                            onClick={onClose}
                            disabled={loading}
                            className="flex-1 py-3 bg-white border border-slate-300 text-slate-700 font-bold rounded-xl hover:bg-slate-50 transition-colors flex justify-center items-center gap-2"
                        >
                            <MdOutlineCancel size={20} /> Cancelar
                        </button>
                        <button
                            onClick={handleSubmit}
                            disabled={loading}
                            className={`flex-1 py-3 text-white font-bold rounded-xl transition-all shadow-md hover:shadow-lg flex justify-center items-center gap-2 ${buttonBg} disabled:opacity-70 disabled:cursor-not-allowed`}
                        >
                            {loading ? (
                                <AiOutlineLoading className="animate-spin" />
                            ) : (
                                <>
                                    <MdCheckCircle size={20} /> Confirmar
                                </>
                            )}
                        </button>
                    </div>

                </div>
            </div>
        </ModalPortal>
    );
};

export default RegistryTransactionModal;